import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
            <div className="md:col-span-5">
              <Link to="/" className="inline-block mb-6">
                <span className="font-heading text-3xl md:text-4xl font-bold text-white">yoybuyfinds.lat</span>
              </Link>
              <p className="text-background-100/70 text-sm leading-relaxed max-w-md mb-6">
                {t('footer.description')}
              </p>
              <div className="flex items-center gap-4">
                <a href="#" rel="noopener nofollow" className="w-10 h-10 rounded-full border border-background-100/20 flex items-center justify-center text-background-100/70 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Telegram">
                  <i className="ri-telegram-line text-lg"></i>
                </a>
                <a href="#" rel="noopener nofollow" className="w-10 h-10 rounded-full border border-background-100/20 flex items-center justify-center text-background-100/70 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-lg"></i>
                </a>
                <a href="#" rel="noopener nofollow" className="w-10 h-10 rounded-full border border-background-100/20 flex items-center justify-center text-background-100/70 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="Pinterest">
                  <i className="ri-pinterest-line text-lg"></i>
                </a>
                <a href="#" rel="noopener nofollow" className="w-10 h-10 rounded-full border border-background-100/20 flex items-center justify-center text-background-100/70 hover:text-white hover:border-white/40 transition-colors cursor-pointer" aria-label="YouTube">
                  <i className="ri-youtube-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-background-100/50 text-xs font-semibold uppercase tracking-wider mb-5">
                {t('nav.contact')}
              </h4>
              <div className="space-y-4">
                <div>
                  <p className="text-background-100/70 text-sm">{t('footer.address_line1')}</p>
                  <p className="text-background-100/70 text-sm">{t('footer.address_line2')}</p>
                </div>
                <div>
                  <p className="text-background-100/70 text-sm">{t('footer.phone')}</p>
                </div>
                <div>
                  <p className="text-background-100/70 text-sm">{t('footer.email')}</p>
                </div>
              </div>
            </div>

            <div className="md:col-span-4">
              <div className="w-full h-48 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20with%20fashion%20items%20on%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20clean%20aesthetic%20composition%2C%20neutral%20warm%20tones%2C%20editorial%20style%2C%20elegant%20arrangement%20of%20accessories%20and%20clothing%2C%20high%20quality%20detail&width=800&height=600&seq=footer-image-01&orientation=portrait"
                  alt="Yoybuy Finds fashion"
                  className="w-full h-full object-cover rounded-lg"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-100/10">
        <div className="px-4 md:px-6 py-5">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-background-100/40 text-xs">
              {t('footer.copyright')}
            </p>
            <div className="flex items-center gap-6">
              <a href="#" rel="noopener nofollow" className="text-background-100/40 text-xs hover:text-background-100/70 transition-colors whitespace-nowrap">
                {t('footer.privacy')}
              </a>
              <a href="#" rel="noopener nofollow" className="text-background-100/40 text-xs hover:text-background-100/70 transition-colors whitespace-nowrap">
                {t('footer.terms')}
              </a>
              <a href="#" rel="noopener nofollow" className="text-background-100/40 text-xs hover:text-background-100/70 transition-colors whitespace-nowrap">
                {t('footer.disclaimer')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}